function normalize(value) {
  return (value || "").toLowerCase().trim();
}

function includesAny(text, keywords) {
  return keywords.some((keyword) => text.includes(keyword));
}

function parseTypes(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

function isAirportLike(placeName, address, types) {
  const haystack = `${normalize(placeName)} ${normalize(address)}`;
  const airportKeywords = [
    "airport",
    "terminal",
    "king abdulaziz international airport",
    "king abdulaziz airport",
    "jeddah airport",
    "riyadh airport",
    "king khalid international airport",
    "madinah airport",
    "prince mohammad bin abdulaziz international airport",
  ];

  return (
    types.includes("airport") ||
    types.includes("international_airport") ||
    includesAny(haystack, airportKeywords)
  );
}

function detectCity(placeName, address) {
  const haystack = `${normalize(placeName)} ${normalize(address)}`;

  if (includesAny(haystack, ["jeddah", "jedda"])) return "jeddah";
  if (includesAny(haystack, ["makkah", "mecca", "makkah al mukarramah"])) return "makkah";
  if (includesAny(haystack, ["madinah", "medina", "al madinah"])) return "madinah";
  if (includesAny(haystack, ["riyadh"])) return "riyadh";

  return null;
}

export function classifyTrip({
  mode,
  pickupPlaceName,
  pickupAddress,
  pickupPlaceTypes,
  dropoffPlaceName,
  dropoffAddress,
  dropoffPlaceTypes,
}) {
  if (mode === "hourly") {
    return {
      mode: "hourly",
      tripType: "hourly",
      serviceLabel: "Hourly Booking",
      requiresQuote: false,
      isAirport: false,
      originCity: detectCity(pickupPlaceName, pickupAddress),
      destinationCity: null,
    };
  }

  const pickupTypes = parseTypes(pickupPlaceTypes);
  const dropoffTypes = parseTypes(dropoffPlaceTypes);

  const isAirport =
    isAirportLike(pickupPlaceName, pickupAddress, pickupTypes) ||
    isAirportLike(dropoffPlaceName, dropoffAddress, dropoffTypes);

  const originCity = detectCity(pickupPlaceName, pickupAddress);
  const destinationCity = detectCity(dropoffPlaceName, dropoffAddress);

  if (isAirport) {
    return {
      mode: "dropoff",
      tripType: "airport",
      serviceLabel: "Airport Transfer",
      requiresQuote: false,
      isAirport: true,
      originCity,
      destinationCity,
    };
  }

  if (originCity === "jeddah" && destinationCity === "makkah") {
    return {
      mode: "dropoff",
      tripType: "jeddahMakkah",
      serviceLabel: "Jeddah to Makkah",
      requiresQuote: false,
      isAirport: false,
      originCity,
      destinationCity,
    };
  }

  if (originCity === "makkah" && destinationCity === "madinah") {
    return {
      mode: "dropoff",
      tripType: "makkahMadinah",
      serviceLabel: "Makkah to Madinah",
      requiresQuote: false,
      isAirport: false,
      originCity,
      destinationCity,
    };
  }

  return {
    mode: "dropoff",
    tripType: "general",
    serviceLabel: "One way drop off",
    requiresQuote: true,
    isAirport: false,
    originCity,
    destinationCity,
  };
}
